module.exports = __webpack_public_path__ + "img/living.2aa3c292.gif";